import styles from "@css/modules/ResortSections.module.scss"
import { DiningLocationItem } from "./DiningLocationItem"
import { SlideAppear } from "../../../Animation/SlideAppear"
import { Suspense, useMemo } from "react"

import dynamic from "next/dynamic"

const ClientOnlyAntdTabs = dynamic(() => import("antd").then((mod) => mod.Tabs), {
    ssr: true // This is the crucial part: render only on the client
})
export function DiningLocations({ diningLocations = [] }) {
    const items = useMemo(
        () =>
            diningLocations?.map((i, index) => {
                return {
                    label: (
                        <div suppressHydrationWarning={true} className={styles.tabTitle}>
                            {i.tabTitle}
                        </div>
                    ),
                    key: index,
                    children: i.diningItems?.map((j, jIndex) => <DiningLocationItem {...j} key={`${index}-${jIndex}`} suppressHydrationWarning={true} />)
                }
            }),
        [diningLocations]
    )
    if (!diningLocations?.length) return null
    return (
        <SlideAppear className={styles.diningLocations}>
            <div className={styles.overLocations}>
                <Suspense fallback={null}>
                    <ClientOnlyAntdTabs defaultActiveKey={0} tabBarGutter={24} className={styles.tabsWrapper} items={items} />
                </Suspense>
            </div>
        </SlideAppear>
    )
}
